import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  children: ReactNode;
  rarity?: string;
  type?: string;
}

interface IStyledTag {
  color: string;
  bgColor: string;
  borderColor: string;
}

const StyledTag = styled.div<IStyledTag>`
  display: inline-block;
  background-color: ${(props) => props.bgColor};
  border: 1px solid ${(props) => props.borderColor};
  color: ${(props) => props.color};
  padding: 0.15rem 0.5rem;
  font-size: 0.9rem;
  border-radius: 0.25rem;
  transition: var(--standard-transition);
  text-align: center;
`;

export const Tag = ({ children, rarity, type }: Props) => {
  let bgColor = 'var(--tag-bg-color)';
  let borderColor = 'var(--tag-border-color)';
  let color = 'var(--tag-text-color)';

  if (rarity === 'common') {
    bgColor = 'var(--grey-50)';
    borderColor = 'var(--grey-200)';
    color = 'var(--grey-900)';
  }
  if (rarity === 'rare') {
    bgColor = 'var(--blue-100)';
    borderColor = 'var(--blue-200)';
    color = 'var(--blue-900)';
  }
  if (rarity === 'epic') {
    bgColor = 'var(--green-100)';
    borderColor = 'var(--green-200)';
    color = 'var(--green-900)';
  }
  if (rarity === 'legendary') {
    bgColor = 'var(--purple-100)';
    borderColor = 'var(--purple-200)';
    color = 'var(--purple-900)';
  }

  return (
    <StyledTag color={color} borderColor={borderColor} bgColor={bgColor}>
      {children}
    </StyledTag>
  );
};
